<div class="row mt-2">
  <div class="col-12">
    <!-- TITULO -->
    <div [ngClass]="isModal ? 'modal-header' : 'row'">
      <div [ngClass]="{ 'col-12': !isModal }">
        <h3 class="heading-5">
          {{ (editing ? "hotel.custom.title-edit" : "hotel.custom.title") | translate }}
        </h3>
      </div>
      <button *ngIf="isModal" type="button" class="close" aria-label="Close" (click)="closeModalCross()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <!-- FORMULARIO -->
    <div [ngClass]="isModal ? 'modal-body' : 'row'">
      <div [ngClass]="{ 'col-12': !isModal }">
        <div [ngClass]="{ 'card border-search': !isModal }">
          <div class="card-body">
            <div *ngIf="loading" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <app-loading [userType]="'user'"></app-loading>
            </div>
            <form [formGroup]="form" [ngClass]="{ 'loading-background': loading }" (ngSubmit)="
                form.valid && !loading ? onSubmit() : (isInvalid = true)
              ">
              <div class="row mt-2"
                *ngIf="editing && (userType?.toLowerCase() === 'employee' || userType?.toLowerCase() === 'company') ">  
                <div class="col-12" style="margin-bottom: 1.5rem;">
                  <div class="form-group dropdown-container">
                    <label class="pt-0 pb-0">{{ "common.traveller" | translate }}</label>
                    <mat-form-field appearance="fill" class="full-width travellers">
                      <mat-select formControlName="traveler" multiple [disabled]="loading" (openedChange)="onTravelerOpenedChange($event)">
                        <mat-select-trigger>
                          <span *ngIf="selectedTravelers.length === 0">
                            {{ "hotel.select-travelers" | translate }}
                          </span>
                          <span *ngIf="selectedTravelers.length > 0">
                            {{ selectedTravelersNames }}
                          </span>
                        </mat-select-trigger>
                        <mat-option class="search-option" disabled>
                          <input
                            class="custom-mat-input"
                            matInput
                            (input)="applyFilter($event.target.value)"
                            (click)="$event.stopPropagation()"
                            placeholder="{{ 'common.search-user' | translate }}"
                          />
                        </mat-option>
                        <mat-option
                          *ngFor="let user of filteredUsers; trackBy: trackByUuid"
                          [value]="user.uuid"
                          (onSelectionChange)="onTravelerOptionToggle(user.uuid, $event)"
                        >
                          {{ user.name }} {{ user.lastname }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="userType === 'EMPLOYEE' && editing">
                <div class="col-6">
                  <div class="form-group">
                    <label class="label-padding">{{ "flight" + ".create-" + "flight" + ".booked-file" | translate
                      }}*</label>
                    <div>
                      <input formControlName="file" type="file" id="file" class="inputFile"
                        (change)="onFileChange($event)" accept="application/pdf" multiple />
                      <label for="file" class="labelFile" [class.disabled]="userType !== 'EMPLOYEE'">
                        {{ "common.choose-file" | translate }}
                      </label>
                      <div class="file-tags"
                        *ngIf="(files?.length > 0 || existingFiles?.length > 0); else showFileBack">
                        <span *ngFor="let f of existingFiles; let i = index" class="file-tag">
                          {{ f.name }}
                          <button type="button" class="remove-btn" (click)="removeFile(i)">x</button>
                        </span>
                        <span *ngFor="let f of files; let i = index" class="file-tag">
                          {{ f.name }}
                          <button type="button" class="remove-btn" (click)="removeFile(i)">x</button>
                        </span>
                      </div>
                      <ng-template #showFileBack>
                        <label class="pl-3" *ngIf="fileBack">
                          {{ fileBack.name }}
                        </label>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="col-6 pd" style="display: flex; justify-content: space-around;">
                  <div class="form-group">
                    <mat-checkbox class="example-margin" formControlName="freeTaxes"
                      *ngIf="!(this.editing && this.data.codePetition) && !data?.hotel">
                      <small>{{ "expenses.freeTaxes" | translate }}</small>
                    </mat-checkbox>
                  </div>
                </div>
              </div>

              <div class="row" style="margin-top: 0.5rem;" *ngIf="userType === 'EMPLOYEE' && editing">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="form-group">
                    <label>{{ 'company.company-booked.wholesale-price' | translate }}</label>
                    <input
                      formControlName="wholesalePrice"
                      placeholder="{{ 'company.company-booked.wholesale-price' | translate }}"
                      type="text"
                      id="wholesalePrice"
                      class="form-control"
                      [disabled]="data?.refund || data?.payment"
                      [ngClass]="{
                        'input-error':
                          !form.controls.wholesalePrice.valid &&
                          isInvalid &&
                          !form.controls.wholesalePrice.disabled
                      }"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <label>{{ 'company.company-booked.booked-price' | translate }}</label>
                  <input formControlName="price" placeholder="{{
                    'company.company-booked.booked-price' | translate
                    }}" type="text" id="price" class="form-control" [disabled]="data?.refund || data?.payment"
                    [ngClass]="{
                    'input-error': !form.controls.price.valid && isInvalid && !form.controls.price.disabled
                    }" />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12"
                  *ngIf="userType === 'EMPLOYEE'">
                  <div class="form-group">
                    <label>{{ 'my-bookeds.train-flight.locator' | translate }}</label>
                    <input formControlName="locator" placeholder="{{ 'my-bookeds.train-flight.locator' | translate }}"
                      type="text" id="locator" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12 travellers-container"
                  *ngIf="defaultUser && !data?.hotel && userType === 'EMPLOYEE' && bookType !== 'airbnb'">
                  <div *ngIf="!editing && form.get('rooms')?.value" class="room-selection">
                    <label>{{ "hotel.custom.rooms" | translate }}</label>
                    <mat-form-field appearance="fill" class="full-width travellers booktype-compact">
                      <mat-select formControlName="rooms" [disabled]="editing || loading" placeholder="{{ 'hotel.custom.rooms' | translate }}">
                        <mat-option *ngFor="let n of [1,2,3,4,5,6,7,8,9,10]" [value]="n">
                          {{ n }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 1rem;">
                <mat-accordion *ngIf="form.get('roomsInfo') && !editing && getTravelersPerRoom.length === form.get('rooms').value - 1">
                <mat-expansion-panel style="margin-bottom: 1.5rem !important; gap: 0 !important;"
                  *ngFor="let roomControl of form.get('roomsInfo')['controls']; let i = index"
                  [formGroup]="roomControl">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ 'hotel.room' | translate }} {{ i + 1 }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div class="form-row two-cols">
                    <div class="form-group" style="margin-bottom: 0 !important; padding: 0rem 1.5rem;">
                      <div>
                        <input type="file" [id]="'file-' + i" class="inputFile" (change)="onFileChangeCustom($event, i)"
                          accept="application/pdf" multiple />
                          <label [for]="'file-' + i" class="labelFile" [class.disabled]="userType !== 'EMPLOYEE'">
                            {{ "common.choose-file" | translate }}
                          </label>
                        <div class="file-tags mt-2">
                          <span *ngFor="let f of roomControl.get('files').value; let j = index">
                            {{ f.name }}
                            <button type="button" class="remove-btn" (click)="removeFileCustom(i, j)">x</button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 price-container" style="justify-content: center;">
                      <mat-checkbox *ngIf="!data?.hotel" formControlName="freeTaxes" class="mb-2">
                        <small>{{ "expenses.freeTaxes" | translate }}</small>
                      </mat-checkbox>
                    </div>
                  </div>

                  <div class="form-row two-cols" style="justify-content: space-around; margin: 0.5rem 0rem !important; padding: 0 0.5rem;">
                    <div class="form-group" style="margin-right: 1rem;">
                      <label>{{ 'company.company-booked.wholesale-price' | translate }}</label>
                      <input class="form-control" type="text" formControlName="wholesalePrice"
                            placeholder="{{ 'company.company-booked.wholesale-price' | translate }}" />
                    </div>
                    <div class="form-group">
                      <label>{{ 'company.company-booked.booked-price' | translate }}</label>
                      <input class="form-control" type="text" formControlName="price"
                      placeholder="{{ 'company.company-booked.booked-price' | translate }}" />
                    </div>
                  </div>
                  <div class="form-group" style="width: 100% !important; padding: 0 0.5rem;">
                    <label class="label-padding">{{ "hotel.people-per-room" | translate }} {{ i + 1 }}</label>
                    <mat-form-field appearance="fill" class="full-width travellers">
                      <mat-select [formControl]="i === 0 ? form.get('defaultTraveler') : getTravelersPerRoom.at(i - 1)"
                        multiple [compareWith]="compareUsers" [disabled]="loading" (openedChange)="onSelectToggle($event)">
                        <mat-option class="search-option" disabled>
                          <input class="custom-mat-input" matInput (input)="applyFilter($event.target.value)"
                            (click)="$event.stopPropagation()" placeholder="{{ 'common.search-user' | translate }}" />
                        </mat-option>
                        <mat-option *ngIf="i === 0 && defaultUser" [value]="defaultUser" disabled>
                          {{ defaultUser.name }} {{ defaultUser.lastname }}
                        </mat-option>
                        <ng-container *ngFor="let user of filteredUsers">
                          <mat-option *ngIf="i !== 0 || user.uuid !== defaultUser?.uuid" [value]="user">
                            {{ user.name }} {{ user.lastname }}
                          </mat-option>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="form-row two-cols" style="padding: 0 0.5rem;">
                    <div class="form-group">
                      <label>{{ 'search.search-booked.room-type' | translate }}</label>
                      <input class="form-control" formControlName="roomType"
                        placeholder="{{ 'search.search-booked.room-type' | translate }}" />
                    </div>
                    <div class="form-group">
                      <label>{{ 'my-bookeds.view.rules' | translate }}</label>
                      <input class="form-control" formControlName="boardType"
                        placeholder="{{ 'my-bookeds.view.rules' | translate }}" />
                    </div>
                  </div>
                  <div class="form-row two-cols" style="padding: 0 0.5rem;" *ngIf="userType === 'EMPLOYEE'">
                    <div class="form-group">
                      <label>{{ 'my-bookeds.view.provider' | translate }}</label>
                      <mat-form-field appearance="fill" class="full-width travellers">
                        <mat-select [formControlName]="'provider'" [disabled]="loading || loadingHotelProviders"
                                  placeholder="{{ 'my-bookeds.view.provider' | translate }}">
                        <mat-option *ngIf="!loadingHotelProviders && !hotelProviderOptions.length" disabled>
                          {{ "common.no-providers-available" | translate }}
                        </mat-option>
                        <mat-option *ngFor="let opt of hotelProviderOptions" [value]="opt.uuid">
                          {{ opt.name }}
                        </mat-option>
                      </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="form-group">
                        <label>{{ 'my-bookeds.view.marketing-fee' | translate }}</label>
                        <input
                          formControlName="marketingFee"
                          placeholder="{{ 'my-bookeds.view.marketing-fee' | translate }}"
                          type="text"
                          id="marketingFee"
                          class="form-control"
                        />
                    </div>
                  </div>
                </mat-expansion-panel>
                </mat-accordion>
              </div>

              <div class="row" *ngIf="userType === 'EMPLOYEE'">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="form-group">
                    <label>{{ 'hotel.custom.hotel-name' | translate }}</label>
                    <input formControlName="hotel" placeholder="{{ 'hotel.custom.hotel-name' | translate }}"
                      [matAutocomplete]="hotel" (input)="getHotels($event.target.value)" type="text" id="origin"
                      class="form-control" [ngClass]="{
                        'input-error': !form.controls.hotel.valid && isInvalid
                      }" />
                    <mat-autocomplete #hotel="matAutocomplete" panelWidth="20%" (optionSelected)="cleanHotelsList()">
                      <mat-option *ngFor="let option of hotelsList" [value]="option">
                        {{ option }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="!data?.hotel">
                  <div class="form-group">
                    <label>{{ 'hotel.custom.city' | translate }}</label>
                    <input formControlName="city" placeholder="{{ 'hotel.custom.city' | translate }}" type="text"
                      id="destination" class="form-control custom-control" matInput [matAutocomplete]="city"
                      (input)="getCities($event.target.value)" [ngClass]="{
                        'input-error': !form.controls.city.valid && isInvalid
                      }" />
                    <mat-autocomplete #city="matAutocomplete" panelWidth="20%"
                      (optionSelected)="cleanCitiesList($event.option.value)">
                      <mat-option *ngFor="let option of citiesList" [value]="option">
                        {{ option }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="userType === 'EMPLOYEE' && data?.hotel">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="form-group">
                    <label>{{ 'common.address' | translate }}</label>
                    <input formControlName="address" placeholder="{{ 'common.address' | translate }}" type="text"
                      id="address" class="form-control" matInput [ngClass]="{
                        'input-error': !form.controls.city.valid && isInvalid
                      }" />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12" *ngIf="data?.hotel">
                  <div class="form-group">
                    <label>{{ 'company.hotel.custom.city' | translate }}</label>
                    <input formControlName="city" placeholder="{{ 'company.hotel.custom.city' | translate }}"
                      type="text" id="destination" class="form-control" matInput [matAutocomplete]="city"
                      (input)="getCities($event.target.value)" [ngClass]="{
                        'input-error': !form.controls.city.valid && isInvalid
                      }" />
                    <mat-autocomplete #city="matAutocomplete" panelWidth="20%"
                      (optionSelected)="cleanCitiesList($event.option.value)">
                      <mat-option *ngFor="let option of citiesList" [value]="option">
                        {{ option }}
                      </mat-option>
                    </mat-autocomplete>
                  </div>
                </div>
              </div>

              <div style="margin-bottom: 0.5rem;" class="row" *ngIf="userType === 'EMPLOYEE'">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <label>{{ 'search.search-homepage.date-entry' | translate }}</label>
                  <div class="form-group d-flex align-items-center">
                    <div class="input-group inputDateTime">
                      <input class="form-control filter-dates-placeholder" [disabled]="this.userType != 'EMPLOYEE'"
                        readonly placeholder="{{
                          'search.search-homepage.date-entry' | translate
                        }}" name="checkIn" id="checkIn" formControlName="checkIn" ngbDatepicker
                        #dDeparture="ngbDatepicker" (click)="dDeparture.toggle()" [minDate]="minDateNgStruct"
                        [maxDate]="maxDateNgStruct" [ngClass]="{
                          'input-error':
                            !form.controls.checkIn.valid && isInvalid
                        }" />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <label>{{ 'search.search-homepage.date-departure' | translate }}</label>
                  <div class="form-group d-flex align-items-center">
                    <div class="input-group inputDateTime">
                      <input mat-button [disabled]="f.checkIn.hasError('required') || this.userType != 'EMPLOYEE'"
                        [ngClass]="{ dates: !f.checkIn.hasError('required') }"
                        class="form-control filter-dates-placeholder" placeholder="{{
                          'search.search-homepage.date-departure' | translate
                        }}" name="checkOut" id="checkOut" formControlName="checkOut" (click)="dReturn.toggle()"
                        ngbDatepicker #dReturn="ngbDatepicker" [minDate]="getOutMinDateManual()"
                        [maxDate]="maxDateNgStruct" [ngClass]="{
                          'input-error':
                            !form.controls.checkOut.valid && isInvalid
                        }" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2" *ngIf="userType === 'EMPLOYEE' && editing && !data?.hotel && bookType !== 'airbnb'">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="form-group">
                    <label class="label-padding">{{ 'search.search-booked.room-type' | translate }}</label>
                    <input class="form-control" formControlName="roomType"
                      placeholder="{{ 'search.search-booked.room-type' | translate }}" />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="form-group">
                    <label class="label-padding">{{ 'my-bookeds.view.rules' | translate }}</label>
                    <input class="form-control" formControlName="boardType"
                      placeholder="{{ 'my-bookeds.view.rules' | translate }}" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="form-group">
                    <label>{{ 'common.custom-code' | translate }}</label>
                    <input formControlName="customCode" placeholder="{{ 'common.custom-code' | translate }}" type="text"
                      id="customCode" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                  <div class="form-group">
                    <label>{{ 'common.cost-center' | translate }}</label>
                    <input formControlName="costCenter" placeholder="{{ 'common.cost-center' | translate }}" type="text"
                      id="costCenter" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="userType === 'EMPLOYEE' && editing">
                <div class="col-12">
                  <label>{{ 'my-bookeds.view.provider' | translate }}</label>
                  <mat-form-field style="font-size: small;" appearance="fill" class="full-width travellers">
                    <mat-select [formControlName]="'provider'"
                                [disabled]="loading || loadingHotelProviders"
                                placeholder="{{ 'my-bookeds.view.provider' | translate }}">
                      <mat-option *ngIf="!loadingHotelProviders && !hotelProviderOptions.length" disabled>
                        {{ "common.no-providers-available" | translate }}
                      </mat-option>
                      <mat-option *ngFor="let opt of hotelProviderOptions" [value]="opt.uuid">
                        {{ opt.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row" *ngIf="userType === 'EMPLOYEE' && editing">
                <div class="col-12">
                  <div class="form-group">
                    <label>{{ 'my-bookeds.view.marketing-fee' | translate }}</label>
                    <input
                      formControlName="marketingFee"
                      placeholder="{{ 'my-bookeds.view.marketing-fee' | translate }}"
                      type="text"
                      id="marketingFeeEdit"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="userType === 'EMPLOYEE'">
                <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center;">
                  <div class="form-group" style="width: 100% !important;">
                    <label>{{ 'company.bills.supplier-invoice' | translate }}</label>
                    <input formControlName="supplierInvoice" placeholder="{{ 'company.bills.supplier-invoice' | translate }}" type="text"
                      id="supplierInvoice" class="form-control" />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center; padding-bottom: 1rem;">
                  <div class="form-group" style="width: 100% !important;">
                    <label>{{ 'company.company-booked.booking-type' | translate }}</label>
                    <mat-form-field appearance="fill"
                                    class="full-width travellers booktype-compact"
                                    floatLabel="never">
                      <mat-select formControlName="bookType"
                                  [disabled]="loading"
                                  placeholder="{{ 'company.company-booked.booking-type' | translate }}">
                        <mat-option value="automatic">{{ 'common.automatic-book' | translate }}</mat-option>
                        <mat-option value="semiautomatic">{{ 'common.semiautomatic-book' | translate }}</mat-option>
                        <mat-option value="manual">{{ 'common.manual-book' | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="userType === 'EMPLOYEE'">
                <div class="col-lg-6 col-md-6 col-xs-12" style="padding-bottom: 1rem;">
                  <div class="form-group">
                    <label>{{ 'company.company-booked.invoiced-status' | translate }}</label>
                    <mat-form-field appearance="fill"
                                    class="full-width travellers booktype-compact"
                                    floatLabel="never">
                      <mat-select formControlName="invoiced"
                                  [disabled]="loading"
                                  placeholder="{{ 'company.company-booked.invoiced-status' | translate }}">
                        <mat-option value="none">
                          {{ 'company.company-booked.invoiced-none' | translate }}
                        </mat-option>
                        <mat-option value="invoiced">
                          {{ 'company.company-booked.invoiced-invoiced' | translate }}
                        </mat-option>
                        <mat-option value="proforma">
                          {{ 'company.company-booked.invoiced-proforma' | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="userType === 'EMPLOYEE'">
                <div class="col-12">
                  <div class="form-group">
                    <div class="form-group">
                      <textarea formControlName="comments" id="comments" class="form-control" placeholder="{{
                          'train.form-train.annotations-request' | translate
                        }}" rows="4"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="w-100 d-flex justify-content-end">
                    <button type="submit" class="custom-btn mt-2 mb-0" ngbAutofocus mat-button [ngStyle]="{
                        cursor:
                          !form.valid || loading || !isFormValid() ? 'not-allowed' : 'pointer'
                      }" [ngClass]="{
                        'disabled-button': !form.valid || loading || !isFormValid()
                      }" [disabled]="!form.valid || !isFormValid() || loading">
                      {{ "common.send" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>